<template>
  <v-app>
    <!-- header -->
    <v-app-bar
      :src="headerBackground"
      app
      clipped-left
      elevate-on-scroll
      dense
      dark
      class="px-0"
    >
      <v-app-bar-nav-icon
        @click="navToggle"
        class="hidden-lg-and-up"
      ></v-app-bar-nav-icon>
      <v-img
        :src="bg"
        max-width="230"
        max-height="40"
        @mousedown="readyToOMG"
      ></v-img>

      <v-spacer></v-spacer>

      <v-menu
        :close-on-content-click="false"
        transition="slide-x-transition"
        offsetY
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-avatar size="36">
              <img :src="userLogo" alt="User" />
            </v-avatar>
            <span class="pl-2 hidden-md-and-down">{{ userName }}</span>
          </div>
        </template>
        <v-card>
          <v-list dense>
            <v-list-item>
              <v-list-item-avatar>
                <img :src="userLogo" alt="User" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ userName }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="openSettingCard">
              <v-list-item-content>
                <v-list-item-title>帳號設定</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-account-cog</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item @click="logout">
              <v-list-item-content>
                <v-list-item-title>登出</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <!-- header end -->

    <!-- nav -->
    <v-navigation-drawer v-model="drawer" :src="navBackground" app clipped dark>
      <v-list shaped nav>
        <v-list-item
          v-for="item in navItems"
          :key="item.title"
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div v-if="userInfo.authLevel == 255">
        <v-list shaped nav>
          <v-list-item
            v-for="item in navItemsAdmin"
            :key="item.title"
            :to="item.route"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
    <!-- nav end -->

    <!-- main content -->

    <v-main class="backgroundImage">
      <!-- <feature /> -->
      <feature class="hidden-lg-and-up" />
      <!-- using vue-router -->
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <!-- main content end-->

    <!-- display user Setting -->
    <userSetting ref="Setting"></userSetting>
  </v-app>
</template>

<script>
import feature from "@/components/Feature.vue";
import userSetting from "@/components/UserSetting.vue";
import { mapActions, mapGetters } from "vuex";
import { router } from "@/plugins/router";
export default {
  created() {
    this.initialize();
  },
  mounted() {
    this.drawer = this.$vuetify.breakpoint.lgAndUp;
    // this.initialize();
  },
  components: {
    feature,
    userSetting,
  },
  data: () => ({
    drawer: null,
    timeout: null,
    settings: {
      suppressScrollY: false,
      suppressScrollX: false,
      wheelPropagation: false,
    },
    userLogo: require("@/assets/images/user.jpg"),
    bg: require("@/assets/images/logo-mini1-white.png"),
    navBackground: require("@/assets/images/nav.jpg"),
    headerBackground: require("@/assets/images/header.jpg"),
    navItems: [
      { title: "總覽", icon: "mdi-view-dashboard", route: "/overview" },
      {
        title: "客群分析",
        icon: "mdi-folder-account",
        route: "/customanalysis",
      },
      { title: "標籤分析", icon: "mdi-tag-multiple", route: "/taganalysis" },
    ],
    navItemsAdmin: [
      { title: "使用者管理", icon: "mdi-account-edit", route: "/accountlist" },
    ],
    userInfo: {},
  }),
  methods: {
    initialize() {
      this.$store
        .dispatch("getUserByToken", {
          token: this.$cookies.get("token"),
          checkSelf: true,
        })
        .then(() =>
          this.userInfo = this.getUser
        )
        .catch(function(error) {
          console.log(error);
        });
    },
    ...mapActions("user", ["logout"], "getUserByToken"),
    navToggle() {
      this.drawer = !this.drawer;
    },
    readyToOMG({ buttons }) {
      if (buttons === 7) router.push("/omg").catch((err) => console.log(err)); //中鍵4+左1+右2
    },
    openSettingCard() {
      this.$refs.Setting.openSetting();
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
    userName: () => `${localStorage.ua}@${localStorage.sa}`,
  },
};
</script>

<style lang="css">
.backgroundImage {
  background-image: url("../assets/images/login-bg.jpg");
  position: relative;
  height: 100%;
  width: 100vw;
  background-position: center;
  background-repeat: norepeat;
  background-attachment: fixed;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
}
</style>
